import {
  InstagramPlatform,
  SocialPlatform,
  YoutubePlatform,
} from '@app/modules/social-export/domain/platforms';
import { InstagramExportSettings } from './InstagramExportSettings';
import { YoutubeExportSettings } from './YoutubeExportSettings';

interface Props {
  platform: SocialPlatform;
  fieldPrefix?: string;
}

export function PlatformExportSettings({ platform, fieldPrefix }: Props) {
  if (platform.id === YoutubePlatform.id) {
    return <YoutubeExportSettings fieldPrefix={fieldPrefix} />;
  }

  if (platform.id === InstagramPlatform.id) {
    return <InstagramExportSettings fieldPrefix={fieldPrefix} />;
  }

  return <div />;
}
